import KendoClientDetailUser from "./KendoClientDetailUser";

const ClientUser = (props) => (
    <div className="tab-pane" id="clientUser">
        <div role="tabpanel" className="tab-pane active">
          <div className="table-panel task-table m-t-15">
            <div className="row table-panel-header">
              <div className="col-md-8 col-sm-8">
                <h6>Users</h6>
              </div>
            </div>
            <div className="table-panel-body" id="gridWidth">
              <KendoClientDetailUser clientId={props?.clientId} />
            </div>
          </div>
        </div>
      </div>
  );

export default ClientUser;
